import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { generateUniqueKey } from 'helpers';
import NavigationItem from './NavigationItem';

const BottomNav = ({ ...props }) => {
  return (
    <footer id='footer'>
      {
        props.items.map(navItem => <NavigationItem key={generateUniqueKey()}
          name={navItem.name}
          icon={navItem.icon}
          href={navItem.href}
          isActive={props.activeItem === navItem.name}
          changeActiveItem={props.changeActiveItem}
          displayCount={navItem.displayCount}
          totalItemsCount={navItem.totalItemsCount}
        />)
      }
    </footer>
  );
};

BottomNav.propTypes = {
  items: PropTypes.array.isRequired,
  changeActiveItem: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  activeItem: PropTypes.string.isRequired
};

export default connect((state) => ({}), (dispatch) => ({}))(withRouter(BottomNav));
